<template>
  <div>
    <Nav />
    <!-- 主要内容区 -->
    <div class="flex pt-20 max-w-7xl mx-auto">
      <LeftNav activeItem="security" />
      <main class="flex-1 p-6">
        <div>
          <div class="mb-8">
            <h1 class="text-2xl font-bold text-gray-900">账户安全</h1>
            <p class="text-gray-600 mt-1">管理您的账户安全设置</p>
          </div>
          <div class="space-y-6">
            <div class="bg-white rounded-xl shadow-sm p-6">
              <div class="flex items-center justify-between mb-4">
                <div>
                  <h3 class="text-lg font-semibold text-gray-900">登录密码</h3>
                  <p class="text-sm text-gray-600 mt-1">
                    {{ userInfo.has_password ? "已设置" : "未设置" }}
                  </p>
                </div>
                <button
                  class="text-primary hover:text-secondary text-sm font-medium"
                  @click="showChangePasswordModal = true"
                >
                  修改密码
                </button>
              </div>
            </div>
            <div class="bg-white rounded-xl shadow-sm p-6">
              <div class="flex items-center justify-between mb-4">
                <div>
                  <h3 class="text-lg font-semibold text-gray-900">
                    手机号验证
                  </h3>
                  <p class="text-sm text-gray-600 mt-1">
                    {{
                      userInfo.mobile
                        ? "已绑定手机号：" + userInfo.mobile
                        : "未绑定"
                    }}
                  </p>
                </div>
                <div class="flex items-center space-x-3">
                  <button
                    class="text-primary hover:text-secondary text-sm font-medium"
                    @click="showChangeMobileModal = true"
                  >
                    更换手机号
                  </button>
                </div>
              </div>
            </div>
            <div class="bg-white rounded-xl shadow-sm p-6">
              <div class="flex items-center justify-between mb-4">
                <div>
                  <h3 class="text-lg font-semibold text-gray-900">邮箱验证</h3>
                  <p class="text-sm text-gray-600 mt-1">
                    {{
                      userInfo.email
                        ? "已填写邮箱：" + userInfo.email
                        : "未填写"
                    }}
                  </p>
                </div>
                <div class="flex items-center space-x-3">

                  <button
                    class="text-primary hover:text-secondary text-sm font-medium"
                    @click="showChangeEmailModal = true"
                  >
                    更换邮箱
                  </button>
                </div>
              </div>
            </div>
            <!-- <div class="bg-white rounded-xl shadow-sm p-6">
              <div class="flex items-center justify-between mb-4">
                <div>
                  <h3 class="text-lg font-semibold text-gray-900">微信账号</h3>
                  <p class="text-sm text-gray-600 mt-1">
                    {{
                      userInfo.wechat
                        ? "已绑定微信号：" + userInfo.wechat
                        : "未绑定"
                    }}
                  </p>
                </div>
                <div class="flex items-center space-x-3">
                  <span
                    class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800"
                  >
                    <div class="w-3 h-3 flex items-center justify-center mr-1">
                      <i class="ri-check-line text-xs"></i>
                    </div>
                    已验证
                  </span>
                  <button
                    class="text-primary hover:text-secondary text-sm font-medium"
                  >
                    更换邮箱
                  </button>
                </div>
              </div>
            </div> -->
            <div class="bg-white rounded-xl shadow-sm p-6">
              <div class="flex items-center justify-between mb-4">
                <div>
                  <h3 class="text-lg font-semibold text-gray-900">账户注销</h3>
                  <p class="text-sm text-gray-600 mt-1">
                    注销账户将永久删除您的所有数据，此操作不可恢复
                  </p>
                </div>
                <div class="flex items-center space-x-3">
                  <button
                    class="text-gray-600 hover:text-red-600 text-sm font-medium"
                  >
                    注销账户
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
    <!-- 页脚 -->
    <Footer />

    <!-- 修改密码弹窗 -->
    <div
      v-if="showChangePasswordModal"
      class="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4"
    >
      <div class="bg-white rounded-lg w-full max-w-md">
        <div
          class="flex justify-between items-center p-5 border-b border-gray-200"
        >
          <h3 class="text-lg font-semibold text-gray-900">修改密码</h3>
          <button
            @click="closeChangePasswordModal"
            class="text-gray-500 hover:text-gray-700"
          >
            <i class="ri-close-line text-xl"></i>
          </button>
        </div>
        <form @submit.prevent="handleChangePassword" class="p-5 space-y-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1"
              >当前密码</label
            >
            <input
              type="password"
              v-model="passwordForm.oldPassword"
              placeholder="请输入当前密码，初次设置请留空"
              class="w-full px-4 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-primary focus:border-primary outline-none transition-colors"
              required
            />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1"
              >新密码</label
            >
            <input
              type="password"
              v-model="passwordForm.newPassword"
              placeholder="请输入新密码"
              class="w-full px-4 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-primary focus:border-primary outline-none transition-colors"
              @input="checkPasswordStrength"
              required
            />
            <!-- 密码强度指示器 -->
            <div class="mt-2 flex items-center space-x-2">
              <span class="text-xs text-gray-600">密码强度：</span>
              <div class="flex space-x-1">
                <div
                  class="w-6 h-2 rounded-full"
                  :class="passwordStrengthClass[0]"
                ></div>
                <div
                  class="w-6 h-2 rounded-full"
                  :class="passwordStrengthClass[1]"
                ></div>
                <div
                  class="w-6 h-2 rounded-full"
                  :class="passwordStrengthClass[2]"
                ></div>
                <div
                  class="w-6 h-2 rounded-full"
                  :class="passwordStrengthClass[3]"
                ></div>
              </div>
              <span
                class="text-xs font-medium"
                :class="passwordStrengthTextClass"
                >{{ passwordStrengthText }}</span
              >
            </div>
            <p class="text-xs text-gray-500 mt-1">
              密码长度至少8位，包含字母和数字
            </p>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1"
              >确认新密码</label
            >
            <input
              type="password"
              v-model="passwordForm.confirmPassword"
              placeholder="请再次输入新密码"
              class="w-full px-4 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-primary focus:border-primary outline-none transition-colors"
              @input="validateConfirmPassword"
              required
            />
            <p
              v-if="passwordForm.passwordError"
              class="text-xs text-red-500 mt-1"
            >
              {{ passwordForm.passwordError }}
            </p>
          </div>
          <div class="pt-2 flex space-x-3 justify-end">
            <button
              type="button"
              @click="closeChangePasswordModal"
              class="px-4 py-2 border border-gray-300 rounded hover:bg-gray-50 transition-colors"
            >
              取消
            </button>
            <button
              type="submit"
              class="px-4 py-2 bg-primary text-white rounded hover:bg-primary/90 transition-colors"
              :disabled="isSubmitting || !isFormValid"
              @click="handleChangePassword"
            >
              {{ isSubmitting ? "修改中..." : "确认修改" }}
            </button>
          </div>
        </form>
      </div>
    </div>

    <!-- 更换手机号弹窗 -->
    <div
      v-if="showChangeMobileModal"
      class="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4"
    >
      <div class="bg-white rounded-lg w-full max-w-md">
        <div
          class="flex justify-between items-center p-5 border-b border-gray-200"
        >
          <h3 class="text-lg font-semibold text-gray-900">更换手机号</h3>
          <button
            @click="closeChangeMobileModal"
            class="text-gray-500 hover:text-gray-700"
          >
            <i class="ri-close-line text-xl"></i>
          </button>
        </div>
        <form @submit.prevent="handleChangeMobile" class="p-5 space-y-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1"
              >新手机号</label
            >
            <input
              type="tel"
              v-model="mobileForm.newMobile"
              placeholder="请输入新手机号"
              class="w-full px-4 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-primary focus:border-primary outline-none transition-colors"
              @input="validateMobile"
              required
            />
            <p v-if="mobileForm.mobileError" class="text-xs text-red-500 mt-1">
              {{ mobileForm.mobileError }}
            </p>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1"
              >短信验证码</label
            >
            <div class="flex space-x-2">
              <input
                type="text"
                v-model="mobileForm.smsCode"
                placeholder="请输入短信验证码"
                class="flex-1 px-4 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-primary focus:border-primary outline-none transition-colors"
                required
              />
              <button
                type="button"
                class="px-3 py-2 bg-primary text-white rounded hover:bg-primary/90 transition-colors whitespace-nowrap"
                :disabled="
                  isSendingSmsCode || smsCountdown > 0 || !isMobileValid
                "
                @click="sendSmsCode"
              >
                {{
                  smsCountdown > 0 ? `${smsCountdown}秒后重发` : "获取验证码"
                }}
              </button>
            </div>
          </div>
          <div class="pt-2 flex space-x-3 justify-end">
            <button
              type="button"
              @click="closeChangeMobileModal"
              class="px-4 py-2 border border-gray-300 rounded hover:bg-gray-50 transition-colors"
            >
              取消
            </button>
            <button
              type="submit"
              class="px-4 py-2 bg-primary text-white rounded hover:bg-primary/90 transition-colors"
              :disabled="isMobileSubmitting || !isMobileFormValid"
              @click="handleChangeMobile"
            >
              {{ isMobileSubmitting ? "修改中..." : "确认修改" }}
            </button>
          </div>
        </form>
      </div>
    </div>

    <!-- 修改邮箱弹窗 -->
    <div
      v-if="showChangeEmailModal"
      class="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4"
    >
      <div class="bg-white rounded-lg w-full max-w-md">
        <div
          class="flex justify-between items-center p-5 border-b border-gray-200"
        >
          <h3 class="text-lg font-semibold text-gray-900">修改邮箱</h3>
          <button
            @click="closeChangeEmailModal"
            class="text-gray-500 hover:text-gray-700"
          >
            <i class="ri-close-line text-xl"></i>
          </button>
        </div>
        <form @submit.prevent="handleChangeEmail" class="p-5 space-y-4">

          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1"
              >新邮箱</label
            >
            <input
              type="email"
              v-model="emailForm.newEmail"
              placeholder="请输入新邮箱"
              class="w-full px-4 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-primary focus:border-primary outline-none transition-colors"
              @input="validateEmail"
              required
            />
            <p v-if="emailForm.emailError" class="text-xs text-red-500 mt-1">
              {{ emailForm.emailError }}
            </p>
          </div>
          <div class="pt-2 flex space-x-3 justify-end">
            <button
              type="button"
              @click="closeChangeEmailModal"
              class="px-4 py-2 border border-gray-300 rounded hover:bg-gray-50 transition-colors"
            >
              取消
            </button>
            <button
              type="submit"
              class="px-4 py-2 bg-primary text-white rounded hover:bg-primary/90 transition-colors"
              :disabled="isEmailSubmitting || !isEmailFormValid"
              @click="handleChangeEmail"
            >
              {{ isEmailSubmitting ? "修改中..." : "确认修改" }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/utils/api.js";
import { Message } from "element-ui";
import Nav from "@/components/Nav.vue";
import Footer from "@/components/Footer.vue";
import LeftNav from "@/components/LeftNav.vue";

export default {
  name: "AccountSecurity",
  components: {
    Nav,
    Footer,
    LeftNav,
  },
  data() {
    return {
      userInfo: {},
      userName: "",
      userEmail: "",
      userAvatar: "",
      // 修改密码相关数据
      showChangePasswordModal: false,
      isSubmitting: false,
      passwordForm: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
        passwordError: "",
      },
      // 密码强度相关
      passwordStrength: 0,
      passwordStrengthClass: [
        "bg-gray-200",
        "bg-gray-200",
        "bg-gray-200",
        "bg-gray-200",
      ],
      passwordStrengthText: "弱",
      passwordStrengthTextClass: "text-red-600",
      // 修改手机号相关数据
      showChangeMobileModal: false,
      isMobileSubmitting: false,
      isSendingCode: false,
      isSendingSmsCode: false,
      countdown: 0,
      smsCountdown: 0,
      countdownTimer: null,
      smsCountdownTimer: null,
      isMobileValid: false,
      mobileForm: {
        verificationCode: "",
        newMobile: "",
        smsCode: "",
        mobileError: "",
      },
      // 修改邮箱相关数据
      showChangeEmailModal: false,
      isEmailSubmitting: false,
      isSendingEmailCode: false,
      emailCountdown: 0,
      emailCountdownTimer: null,
      isEmailValid: false,
      emailForm: {
        newEmail: "",
        emailError: "",
      },
    };
  },
  mounted() {
    this.loadUserInfo();
  },
  computed: {
    // 修改密码表单验证
    isFormValid() {
      return (
        this.passwordForm.newPassword &&
        this.passwordForm.confirmPassword &&
        this.passwordForm.newPassword === this.passwordForm.confirmPassword &&
        !this.passwordForm.passwordError &&
        this.passwordStrength >= 2
      ); // 要求密码强度至少为中
    },
    // 修改手机号表单验证
    isMobileFormValid() {
      return (
        this.mobileForm.newMobile &&
        this.mobileForm.smsCode &&
        !this.mobileForm.mobileError &&
        this.isMobileValid
      );
    },
    // 修改邮箱表单验证
    isEmailFormValid() {
      return (
        this.emailForm.newEmail &&
        !this.emailForm.emailError &&
        this.isEmailValid
      );
    },
  },

  methods: {
    // 返回上一页
    goBack() {
      this.$router.back();
    },

    // 清理定时器
    clearTimers() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
      if (this.smsCountdownTimer) {
        clearInterval(this.smsCountdownTimer);
        this.smsCountdownTimer = null;
      }
      if (this.emailCountdownTimer) {
        clearInterval(this.emailCountdownTimer);
        this.emailCountdownTimer = null;
      }
    },

    // 显示修改密码弹窗
    showChangePassword() {
      this.showChangePasswordModal = true;
    },

    // 关闭修改密码弹窗
    closeChangePasswordModal() {
      this.showChangePasswordModal = false;
      this.resetPasswordForm();
    },

    // 关闭更换手机号弹窗
    closeChangeMobileModal() {
      this.showChangeMobileModal = false;
      this.resetMobileForm();
    },

    // 重置手机号表单
    resetMobileForm() {
      this.mobileForm = {
        newMobile: "",
        smsCode: "",
        mobileError: "",
      };
      this.isMobileValid = false;
      this.countdown = 0;
      this.smsCountdown = 0;
    },

    // 验证手机号格式
    validateMobile() {
      const mobile = this.mobileForm.newMobile;
      const mobileRegex = /^1[3-9]\d{9}$/;

      if (!mobile) {
        this.mobileForm.mobileError = "";
        this.isMobileValid = false;
      } else if (!mobileRegex.test(mobile)) {
        this.mobileForm.mobileError = "请输入正确的手机号格式";
        this.isMobileValid = false;
      } else {
        this.mobileForm.mobileError = "";
        this.isMobileValid = true;
      }
    },

    // 发送短信验证码（用于新手机号验证）
    async sendSmsCode() {
      if (!this.isMobileValid) return;

      this.isSendingSmsCode = true;
      try {
        const response = await api.code.send({
          mobile: this.mobileForm.newMobile,
          event: "changemobile",
        });

        // 开始倒计时
        this.startSmsCountdown();
      } catch (error) {
        console.error("发送短信验证码失败:", error);
      } finally {
        this.isSendingSmsCode = false;
      }
    },

    // 开始验证码倒计时
    startCountdown() {
      this.countdown = 60;
      if (this.countdownTimer) clearInterval(this.countdownTimer);
      this.countdownTimer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          clearInterval(this.countdownTimer);
        }
      }, 1000);
    },

    // 开始短信验证码倒计时
    startSmsCountdown() {
      this.smsCountdown = 60;
      if (this.smsCountdownTimer) clearInterval(this.smsCountdownTimer);
      this.smsCountdownTimer = setInterval(() => {
        if (this.smsCountdown > 0) {
          this.smsCountdown--;
        } else {
          clearInterval(this.smsCountdownTimer);
        }
      }, 1000);
    },

    // 处理更换手机号
    async handleChangeMobile() {
      this.isMobileSubmitting = true;
      try {
        // 验证短信验证码并更换手机号
        const response = await api.user.changeMobile({
          mobile: this.mobileForm.newMobile,
          code: this.mobileForm.smsCode,
        });

        this.closeChangeMobileModal();
        // 重新加载用户信息
        this.loadUserInfo();
      } catch (error) {
        console.error("更换手机号失败:", error);
      } finally {
        this.isMobileSubmitting = false;
      }
    },

    // 重置密码表单
    resetPasswordForm() {
      this.passwordForm = {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
        passwordError: "",
      };
      this.passwordStrength = 0;
      this.passwordStrengthClass = [
        "bg-gray-200",
        "bg-gray-200",
        "bg-gray-200",
        "bg-gray-200",
      ];
      this.passwordStrengthText = "弱";
      this.passwordStrengthTextClass = "text-red-600";
    },

    // 检查密码强度
    checkPasswordStrength() {
      const password = this.passwordForm.newPassword;
      if (!password) {
        this.passwordStrength = 0;
        this.updatePasswordStrengthUI();
        return;
      }

      let strength = 0;
      // 长度检查
      if (password.length >= 8) strength++;
      // 包含数字
      if (/\d/.test(password)) strength++;
      // 包含字母
      if (/[a-zA-Z]/.test(password)) strength++;
      // 包含特殊字符
      if (/[^a-zA-Z0-9]/.test(password)) strength++;

      this.passwordStrength = strength;
      this.updatePasswordStrengthUI();
    },

    // 更新密码强度UI
    updatePasswordStrengthUI() {
      const strength = this.passwordStrength;
      const classes = [
        "bg-gray-200",
        "bg-gray-200",
        "bg-gray-200",
        "bg-gray-200",
      ];

      for (let i = 0; i < strength; i++) {
        if (strength === 1) {
          classes[i] = "bg-red-500";
        } else if (strength === 2) {
          classes[i] = "bg-yellow-500";
        } else if (strength >= 3) {
          classes[i] = "bg-green-500";
        }
      }

      this.passwordStrengthClass = classes;

      if (strength === 0) {
        this.passwordStrengthText = "弱";
        this.passwordStrengthTextClass = "text-red-600";
      } else if (strength === 1) {
        this.passwordStrengthText = "弱";
        this.passwordStrengthTextClass = "text-red-600";
      } else if (strength === 2) {
        this.passwordStrengthText = "中";
        this.passwordStrengthTextClass = "text-yellow-600";
      } else if (strength >= 3) {
        this.passwordStrengthText = "强";
        this.passwordStrengthTextClass = "text-green-600";
      }
    },

    // 验证确认密码
    validateConfirmPassword() {
      const newPassword = this.passwordForm.newPassword;
      const confirmPassword = this.passwordForm.confirmPassword;

      if (confirmPassword && newPassword !== confirmPassword) {
        this.passwordForm.passwordError = "两次输入的密码不一致";
      } else {
        this.passwordForm.passwordError = "";
      }
    },

    // 处理密码修改
    async handleChangePassword() {
      if (!this.isFormValid) return;

      this.isSubmitting = true;
      try {
        const response = await api.user.changePassword(this.passwordForm);
        this.closeChangePasswordModal();
        // 退出登录
        if (response.data.code === 200) {
          this.logout();
        }
      } catch (error) {
        console.error("修改密码失败:", error);
      } finally {
        this.isSubmitting = false;
      }
    },

    // 加载用户信息
    async loadUserInfo() {
      try {
        const response = await api.user.getUserInfo();
        this.userInfo = response.data;
      } catch (error) {
        console.error("加载用户信息失败:", error);
      }
    },

    // 跳转到订单页面
    goToOrders() {
      Message.info("即将跳转到订单页面");
      // 实际项目中可以替换为真实的订单页面路由
      // this.$router.push('/ucenter/orders')
    },

    // 跳转到个人资料页面
    goToProfile() {
      Message.info("即将跳转到个人资料页面");
      // 实际项目中可以替换为真实的个人资料页面路由
      // this.$router.push('/ucenter/profile')
    },

    // 跳转到账号设置页面
    goToSettings() {
      Message.info("即将跳转到账号设置页面");
      // 实际项目中可以替换为真实的账号设置页面路由
      // this.$router.push('/ucenter/settings')
    },

    // 跳转到帮助中心
    goToHelp() {
      Message.info("即将跳转到帮助中心");
      // 实际项目中可以替换为真实的帮助中心页面路由
      // this.$router.push('/help')
    },

    // // 退出登录
    async logout() {
      try {
        const result = await this.$store.dispatch("user/logout");
        if (result) {
          setTimeout(() => {
            this.$router.push("/login");
          }, 1500);
        } else {
        }
      } catch (error) {
        console.error("退出登录失败:", error);
      }
    },

    // 关闭修改邮箱弹窗
    closeChangeEmailModal() {
      this.showChangeEmailModal = false;
      this.resetEmailForm();
    },

    // 重置邮箱表单
    resetEmailForm() {
      this.emailForm = {
        newEmail: "",
        emailError: "",
      };
      this.isEmailValid = false;
      this.emailCountdown = 0;
    },

    // 验证邮箱格式
    validateEmail() {
      const email = this.emailForm.newEmail;
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!email) {
        this.emailForm.emailError = "";
        this.isEmailValid = false;
      } else if (!emailRegex.test(email)) {
        this.emailForm.emailError = "请输入正确的邮箱格式";
        this.isEmailValid = false;
      } else {
        this.emailForm.emailError = "";
        this.isEmailValid = true;
      }
    },



    // 处理修改邮箱
    async handleChangeEmail() {
      if (!this.isEmailFormValid) return;

      this.isEmailSubmitting = true;
      try {

          // 提交新邮箱到后台
          const response = await api.user.changeEmail({
            email: this.emailForm.newEmail,
          });


            this.closeChangeEmailModal();
            // 重新加载用户信息
            this.loadUserInfo();


      } catch (error) {
        console.error("修改邮箱失败:", error);
      } finally {
        this.isEmailSubmitting = false;
      }
    },

    // 组件销毁时清理定时器
    beforeDestroy() {
      this.clearTimers();
    },
  },
};
</script>

<style scoped>
/**/
</style>



// WEBPACK FOOTER //
// src/pages/ucenter/Security.vue